import { useEffect, useMemo, useState } from "react";
import useSelect from "~components/Form/hooks/useSelect";
import { db } from "~/db/db";
import prepareForOptions from "~services/utils/prepareForOptions";
import useTrilha from "../useTrilha";
import { getColumnIntoKey } from "~pages/PriceSearchV2/utils/initializerHelpers";

const usePesquisaPrazo = (formikRef, grupoMaterialId = 0, trilha = null) => {
  const pesquisaPrazoSelect = useSelect("pesquisaPrazo");
  const [pesquisaPrazo, setPesquisaPrazo] = useState(0);
  const [pesquisaPrazoObjeto, setPesquisaPrazoObjeto] = useState({});
  const [fila, setFila] = useState(null);

  const { trilhasObjCodigo } = useTrilha();

  const [pesquisaPrazos, setPesquisaPrazos] = useState([]);
  const [pesquisaGrupoMaterialPrazo, setPesquisaGrupoMaterialPrazo] = useState([]);

  useEffect(() => {
    const fetchPesquisaPrazos = async () => {
      const prazos = [];
      await db.pesquisaPrazos.orderBy("ordem").each((prazo) => {
        prazos.push(prazo);
      });
      setPesquisaPrazos(prazos);
    };

    const fetchPesquisaGrupoMaterialPrazo = async () => {
      const grupoMaterialPrazos = [];
      await db.pesquisaGrupoMaterialPrazo.each((grupo) => {
        grupoMaterialPrazos.push(grupo);
      });
      setPesquisaGrupoMaterialPrazo(grupoMaterialPrazos);
    };

    fetchPesquisaPrazos();
    fetchPesquisaGrupoMaterialPrazo();
  }, []);

  const [mostrarPrazoPersonalizado, setMostrarPrazoPersonalizado] = useState(false);

  //OPTIONS
  const pesquisaGrupoMaterialPrazos = useMemo(() => {
    const result = {};
    if (pesquisaGrupoMaterialPrazo?.length) {
      for (const e of pesquisaGrupoMaterialPrazo) {
        result[`${e.pesquisaGrupoMaterialId}/${e.pesquisaPrazoId}`] = true;
      }
    }
    return result;
  }, [pesquisaGrupoMaterialPrazo]);

  const optionPesquisaPrazo = useMemo(() => {
    let temp = [];
    if (grupoMaterialId && grupoMaterialId != 0 && Object.entries(trilhasObjCodigo).length > 0) {
      temp = (pesquisaPrazos || [])
        .filter((e) => {
          const grupoValidacao =
            Object.entries(pesquisaGrupoMaterialPrazos).length > 0 &&
            pesquisaGrupoMaterialPrazos[grupoMaterialId + "/" + e.id];
          const trilhaValidacao = (e.pesquisaTrilhaPrazo || []).some(
            (pt) => trilhasObjCodigo[trilha]?.id == pt.trilhaId
          );

          return grupoValidacao && trilhaValidacao && e.ativo;
        })
        .sort((a, b) => a.ordem - b.ordem);
      temp.push({ nome: "Outros", id: null });
    }

    return prepareForOptions(temp, ["nome"], "id");
  }, [pesquisaPrazos, grupoMaterialId, trilhasObjCodigo, pesquisaGrupoMaterialPrazos]);

  useEffect(() => {
    if (fila && pesquisaPrazos?.length > 0 && Object.keys(pesquisaGrupoMaterialPrazo).length > 0)
      setPesquisaPrazoSelect(fila);

    if (pesquisaPrazos?.length > 0) setPesquisaPrazoObjeto(getColumnIntoKey({ data: pesquisaPrazos, prefix: "id-" }));
  }, [fila, pesquisaPrazos, pesquisaGrupoMaterialPrazos]);

  function setPesquisaPrazoSelect(value) {
    if (value == null) {
      onChangePesquisaPrazo({
        label: "Outros",
        value: null,
      });
    } else if (pesquisaPrazos?.length > 0 && Object.keys(pesquisaGrupoMaterialPrazo).length > 0) {
      const optionPrazo = (pesquisaPrazos || []).find((optPrazo) => optPrazo.id == value);

      if (optionPrazo) {
        onChangePesquisaPrazo({
          label: optionPrazo.nome,
          value: optionPrazo.id,
        });
      }
      setFila(null);
    } else {
      setFila(value);
    }
  }

  function onChangePesquisaPrazo(e) {
    setMostrarPrazoPersonalizado(e.value == null);

    pesquisaPrazoSelect.upDateValue(e.value);
    pesquisaPrazoSelect.upDateDefaultValue(e || "");
    const formikInstance = formikRef?.current;
    if (formikInstance) {
      formikInstance.setFieldValue("prazoId", e.value);

      if (e.value !== null) {
        formikInstance.setFieldValue("outrosPrazos", null);
      }

      setTimeout(() => formikInstance.setFieldTouched("prazoId", true));
    }
  }

  return {
    pesquisaPrazoObjeto,
    pesquisaPrazos,
    optionPesquisaPrazo,
    onChangePesquisaPrazo,
    pesquisaPrazo,
    pesquisaPrazoSelect,
    setPesquisaPrazo,
    setPesquisaPrazoSelect,
    mostrarPrazoPersonalizado,
  };
};

export default usePesquisaPrazo;
